import {DateTimeFormatter, LocalDateTime, nativeJs, Instant, ZoneId} from "@js-joda/core";
import {IInstantProps} from "components/dashboard/product-template-table/utils/cellInterfaces";
import {Calendar, CalendarChangeParams} from "primereact/calendar";
import React, {FormEvent, useEffect, useState} from "react";
import {DEFAULT_DATE_PATTERN} from "utils/constants";

const InstantComponent = (props: IInstantProps) => {
    const [instant, setInstant] = useState<Instant | undefined>(props.value ? Instant.parse(props.value) : undefined);
    const [onCalendarFocus, setOnCalendarFocus] = useState<boolean | undefined>(undefined);

    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const zonedDateTime = instant?.atZone(ZoneId.of(userTimeZone));
    const localDateTime = zonedDateTime?.toLocalDateTime();

    useEffect(() => {
        if (onCalendarFocus === false && instant !== undefined) {
            const utcString = convertDateToUTCString(instant);
            props.changeHandler(utcString)
        }
    }, [onCalendarFocus]);

    const convertDateToUTCString = (date: Instant) => {
       return date.toString();
    }

    const convertDateToFormattedString = (date: LocalDateTime | undefined, formatString: string) => {
        const formatter = DateTimeFormatter.ofPattern(formatString);
        return date?.format(formatter);
    };

    const dateChangeHandler = (e: CalendarChangeParams) => {
        if (e.value) {
            setInstant(Instant.from(nativeJs(e.value)));
        }
    }

    const hasHours = () => {
        let has = true;
        if (props.format) {
            has = props.format.split(' ')[1] !== undefined;
        }
        return has;
    }

    if (props.isInEditMode) {
        return <Calendar hourFormat="24"
                         value={instant ? new Date(instant.toEpochMilli()) : undefined}
                         onChange={(e) => dateChangeHandler(e)}
                         onFocus={() => setOnCalendarFocus(true)}
                         onHide={() => setOnCalendarFocus(false)}
                         onInput={(e: FormEvent<HTMLInputElement>) => {
                             let val = e.target as HTMLInputElement;
                             if (!val.value) {
                                 setInstant(undefined);
                                 props.changeHandler(undefined)
                             }
                         }}
                         showTime={hasHours()}
        />
    } else {
        return <div>
            {convertDateToFormattedString(localDateTime, props.format ?? DEFAULT_DATE_PATTERN)}
        </div>;
    }
};

export default InstantComponent;